import { render } from "./BaseMailto.vue?vue&type=template&id=e7323a08"
import script from "./BaseMailto.vue?vue&type=script&lang=js"
export * from "./BaseMailto.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__